import { render, staticRenderFns } from "./MemberHeaderCard.vue?vue&type=template&id=6d0db183"
import script from "./MemberHeaderCard.vue?vue&type=script&lang=js"
export * from "./MemberHeaderCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports